import { CheckIcon, ExclamationIcon, XIcon } from "@heroicons/react/outline";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import RequestAppointmentResignation from "../modal/RequestAppointmentResignation";
import RequestsModel from "../../api/models/RequestsModel";
import moment from "moment";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
import ApiDateParser from "../../helpers/parsers/apiDateParser";
type AppointmentsRequestsCardProps = {
  showModal: boolean;
  request?: RequestsModel | null;
  changeRequestStatus?: (key1: boolean, key2: number | string) => void;
  owner?: boolean;
};
export default function AppointmentsRequestsCard(
  props: AppointmentsRequestsCardProps
) {
  const { showModal, request, changeRequestStatus, owner } = props;
  const LocalBasePath = "page.tutor.dashboard.requests";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [open, setOpen] = useState<boolean>(false);
  const days: any = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
  };

  const onApprove = () => {
    if (!!changeRequestStatus) changeRequestStatus(true, request?.id ?? "");
    setOpen(false);
  };

  const onDeny = () => {
    if (!!changeRequestStatus) changeRequestStatus(false, request?.id ?? "");
    setOpen(false);
  };

  const renderStatus = useMemo(() => {
    if (request?.status === "rejected")
      return (
        <span className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-red-600 bg-transparent border border-red-600 flex-nowrap rounded-xl ">
          <ExclamationIcon className="flex-shrink-0 w-4 h-4 " />
          {t("haveRejected")}
        </span>
      );
    if (request?.status === "approved")
      return (
        <span className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-green-500 bg-transparent border border-green-500 flex-nowrap rounded-xl ">
          <CheckIcon className="flex-shrink-0 w-4 h-4 " />
          {t("haveAccepted")}
        </span>
      );
    else
      return (
        <div className="flex flex-row items-center gap-3">
          <button
            type="button"
            onClick={onDeny}
            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-red-600 bg-white border border-red-600 rounded-md shadow-sm hover:text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
          >
            <XIcon className="w-5 h-5 " aria-hidden="true" />
            {t("refused")}
          </button>
          <button
            type="button"
            onClick={onApprove}
            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-brandblue-500 focus:ring-offset-2"
          >
            <CheckIcon className="w-5 h-5 " aria-hidden="true" />
            {t("approved")}
          </button>
        </div>
      );
  }, [request]);
  return (
    <>
      <div className="flex flex-col gap-2 pb-4 border-b border-gray-200 ">
        <div className="flex items-center justify-end w-full">
          <p className="text-sm text-gray-400">
            {moment(request?.createdAt).fromNow(true)}
          </p>
        </div>
        <div className="flex flex-col justify-between w-full gap-3 sm:gap-0 sm:flex-row">
          <div className="relative flex items-center gap-1 space-x-3">
            <div className="flex-shrink-0">
              <UserProfilePictureAvatar
                profilePictureUrl={request?.user?.profile_picture_url}
                className="w-10 h-10"
                alt="avatar"
              />
            </div>
            <div className="flex-1 min-w-0">
              <a href="#" className="focus:outline-none">
                <span className="absolute inset-0" aria-hidden="true" />
                <p className="text-lg font-semibold text-gray-500">
                  {request?.user?.fullNameWithoutMiddle}
                </p>
              </a>
            </div>
          </div>
          {renderStatus}
        </div>
        {!!request?.slots?.length && (
          <div className="flex flex-col w-full gap-2">
            <div className="flex flex-col w-full gap-2 sm:gap-0 sm:flex-row sm:justify-between ">
              <p className="text-xl font-medium leading-8 text-gray-800">
                {t("proposedSchedule")}
              </p>
              {!!showModal && (
                <button
                  onClick={() => setOpen(true)}
                  className="text-sm font-medium text-justify underline text-brandblue-600 "
                >
                  {t("showRecentCalendar")}
                </button>
              )}
            </div>
            <div className="flex flex-col w-full gap-4 sm:flex-row sm:items-center ">
              {request?.slots.map((slot) => (
                <div className="flex flex-col gap-1 w-80">
                  <h4 className="text-sm text-gray-500 ">
                    {moment()
                      .day(days?.[slot?.day_of_the_week] ?? 0)
                      .format("dddd")}
                  </h4>
                  <p className="text-base leading-5 text-brandblue-600">
                    {ApiDateParser.parse(slot?.start_time).format("hh:mm A")}

                    {"  -  "}
                    {ApiDateParser.parse(slot?.end_time).format("hh:mm A")}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <RequestAppointmentResignation
        open={open}
        setOpen={(newValue: boolean) => setOpen(false)}
        owner={!!owner}
        request={request}
        onApprove={onApprove}
        onDeny={onDeny}
      />
    </>
  );
}
